// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3wZio","title":"ClientInsurance_title__1Aef7","itemText":"ClientInsurance_itemText__38mAF"};